import http from "../common/http-common";

export async function getAllBrands() {  
  return await http.get("/brands");
}

export async function addBrands(data) {
  return await http.post("/brands", data);
}

export async function getBrandsDetail(id) {  
  return await http.get(`/brands/${id}`);
}

export async function updateBrandsDetail(id, data) {    
  return await http.put(`/brands/${id}`, data);
}

export async function deleteBrandsDetail(id) {
  return await http.delete(`/brands/${id}`);
}
